import { styled } from 'styled-system/jsx'

const ManagerRoot = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
  },
})

const Lede = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'quickpass.inkSoft',
    margin: '0',
    lineHeight: '1.5',
  },
})

const VerificationRow = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
    padding: '16px',
    borderRadius: 'md',
    border: '1px solid',
    borderColor: '#EAE6F5',
    backgroundColor: '#FFFFFF',
    flexWrap: 'wrap',
  },
})

const RowLeft = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    minWidth: '0',
  },
})

const RowIcon = styled('span', {
  base: {
    fontSize: '22px',
    lineHeight: '1',
    flexShrink: '0',
  },
})

const RowText = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    minWidth: '0',
  },
})

const VisibilityRow = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
    padding: '14px 16px',
    marginTop: '-8px',
    borderRadius: 'md',
    border: '1px solid',
    borderColor: '#EAE6F5',
    backgroundColor: '#FBFAFF',
    flexWrap: 'wrap',
  },
})

const VisibilityText = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    minWidth: '0',
  },
})

const VisibilityName = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const VisibilityDescription = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
    lineHeight: '1.45',
  },
})

const RowTitle = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '15px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const RowSubtitle = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
    lineHeight: '1.4',
  },
})

const RowRight = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexShrink: '0',
  },
})

const StatusPill = styled('span', {
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
    paddingX: '10px',
    paddingY: '4px',
    borderRadius: 'pill',
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '700',
    whiteSpace: 'nowrap',
  },
  variants: {
    tone: {
      neutral: { backgroundColor: '#EEF0F4', color: '#5A6472' },
      pending: { backgroundColor: '#FFF3D6', color: '#8A5B00' },
      verified: { backgroundColor: '#D7F5E1', color: '#10663A' },
      failed: { backgroundColor: '#FCE2E2', color: '#9A2222' },
    },
  },
})

const GroupTitle = styled('h4', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '700',
    color: 'quickpass.inkSoft',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    margin: '6px 0 0 0',
  },
})

const BankActions = styled('div', {
  base: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
})

const PrivacyNote = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: 'quickpass.inkSoft',
    margin: '0',
    lineHeight: '1.45',
  },
})

const Banner = styled('div', {
  base: {
    paddingX: '14px',
    paddingY: '10px',
    borderRadius: 'sm',
    fontFamily: 'body',
    fontSize: '13px',
    lineHeight: '1.45',
  },
  variants: {
    tone: {
      info: { backgroundColor: '#EEF2FF', color: 'quickpass.primary' },
      error: { backgroundColor: '#FCE2E2', color: '#9A2222' },
    },
  },
})

const PrivacyPolicyLink = styled('a', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '600',
    color: 'quickpass.primary',
    textDecoration: 'underline',
    textUnderlineOffset: '2px',
    _hover: { textDecoration: 'none' },
  },
})

export {
  ManagerRoot,
  Lede,
  VerificationRow,
  RowLeft,
  RowIcon,
  RowText,
  RowTitle,
  RowSubtitle,
  RowRight,
  VisibilityRow,
  VisibilityText,
  VisibilityName,
  VisibilityDescription,
  StatusPill,
  GroupTitle,
  BankActions,
  PrivacyNote,
  PrivacyPolicyLink,
  Banner,
}
